import { Grid, IconButton, makeStyles } from "@material-ui/core";
import HelpIcon from "@material-ui/icons/Help";
import PropTypes from "prop-types";
import { lang } from "../../../i18nLang";
import MenuProfile from "./MenuProfile";

const helpUrl =
  "https://documentacao.senior.com.br/rubk/faturamento/manual-do-usuario/";

const useStyles = makeStyles((theme) => ({
  button_icon: {
    color: theme.palette.white,
    padding: theme.spacing(3, 2),
  },
  icon: {
    fontSize: "1.4rem",
  },
}));

type IProps = {
  onlyHelpAction?: boolean;
};

function ToolBar({ onlyHelpAction }: IProps) {
  const classes = useStyles();

  const handleClickHelp = (ev) => {
    ev.stopPropagation();
    window.open(helpUrl);
  };

  return (
    <Grid
      container
      item
      xs={2}
      md={4}
      alignItems="center"
      justifyContent="flex-end"
    >
      <IconButton
        className={classes.button_icon}
        title={lang("help")}
        onClick={handleClickHelp}
      >
        <HelpIcon className={classes.icon} />
      </IconButton>
      {!onlyHelpAction && <MenuProfile classes={classes} />}
    </Grid>
  );
}

ToolBar.propTypes = {
  /** Desabilita as outras opções da ToolBar. */
  onlyHelpAction: PropTypes.bool,
};

export default ToolBar;
